var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.tabClass }, [
    _c("div", { staticClass: "tabs" }, [
      _c(
        "div",
        { staticClass: "tabs__elements g-cols g-cols--3-md g-cols--n_height" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tabs__item",
              class: { "tabs__item--isactive": tab.isActive },
              on: {
                click: function($event) {
                  return _vm.selectTab(tab)
                }
              }
            },
            [_c("p", { staticClass: "tabs__name" }, [_vm._v(_vm._s(tab.name))])]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "tabs__details g-cols g-cols--auto-md" },
        [_vm._t("default")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-781dc776", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781dc776","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiTabs/TabsUi.vue
// module id = 140
// module chunks = 0